function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "#073C50",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M16.9339815,3.3980549 L2.74517889,8.69988969 C1.77193637,9.06793853 1.78978531,9.59120356 2.5790311,9.83273206 L6.21081222,10.9310944 L14.6374678,5.79020379 C15.029106,5.53716318 15.3910727,5.68092348 15.0943598,5.93396409 L8.27592447,11.9028804 L8.01479369,15.5314239 C8.39460985,15.5314239 8.56075764,15.3703675 8.75657707,15.1806151 L10.5309451,13.5245077 L14.2101886,16.1524572 C14.880749,16.5204499 15.3614016,16.3306975 15.5394291,15.5486639 L17.9546865,4.51938519 C18.1683548,3.5532711 17.5927198,3.16803843 16.9339815,3.3980549 Z"
}));

var SvgTelegram = function SvgTelegram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTelegram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telegram.4a18130e.svg";
export { ForwardRef as ReactComponent };